import type { ProductCategory } from '../core/types/catalog'

// De werkwijze ("Kijken, Kiezen, Opbouwen") staat in Paginateksten:
// `pages.home.story.steps` (data/pages.ts), zodat Sarah hem zelf kan aanpassen.

export type ResultMoment = { when: string; what: string }

const fallback: ResultMoment[] = [
  { when: 'Eerste week', what: 'Je huid went aan het product en voelt direct verzorgd.' },
  { when: 'Na 4 weken', what: 'Eén volledige huidcyclus: textuur en balans verbeteren zichtbaar.' },
  { when: 'Na 12 weken', what: 'Het echte resultaat. Hier zie je waarom geduld loont.' },
]

/**
 * Eerlijke verwachtingen per productsoort, gebaseerd op de huidcyclus van ±28 dagen.
 * Voorkomt dat klanten na twee weken afhaken omdat ze 'niets zien'.
 */
export const resultsByCategory: Partial<Record<ProductCategory, ResultMoment[]>> = {
  Serum: [
    { when: 'Eerste week', what: 'Huid voelt soepeler en oogt frisser, vooral ’s ochtends.' },
    { when: 'Na 4 weken', what: 'Egalere teint en meer glow — één volledige huidcyclus.' },
    { when: 'Na 12 weken', what: 'Pigmentvlekken en fijne lijntjes zichtbaar zachter.' },
  ],
  Crème: [
    { when: 'Direct', what: 'Trekkerig gevoel verdwijnt, huid voelt comfortabel.' },
    { when: 'Na 2 weken', what: 'Huidbarrière herstelt: minder roodheid en schilfertjes.' },
    { when: 'Na 8 weken', what: 'Stevigere, voller ogende huid met meer veerkracht.' },
  ],
  Olie: [
    { when: 'Direct', what: 'Zachte, gevoede huid zonder vettig laagje.' },
    { when: 'Na 3 weken', what: 'Minder onrust en ontstekingen rond je cyclus.' },
    { when: 'Na 8 weken', what: 'Rustiger, gebalanceerde huid met een natuurlijke glans.' },
  ],
  SPF: [
    { when: 'Elke dag', what: 'Beschermt het resultaat van al je andere producten.' },
    { when: 'Na 4 weken', what: 'Pigment krijgt geen kans om terug te komen.' },
    { when: 'Op lange termijn', what: 'De meest effectieve anti-aging die er bestaat.' },
  ],
  Masker: [
    { when: 'Direct', what: 'Poriën ogen fijner, huid voelt schoon en helder.' },
    { when: 'Na 3 weken', what: 'Minder onzuiverheden bij wekelijks gebruik.' },
    { when: 'Na 8 weken', what: 'Evenwichtiger talgproductie, egalere huid.' },
  ],
}

export function resultsFor(category: ProductCategory): ResultMoment[] {
  return resultsByCategory[category] ?? fallback
}
